import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { camelCase } from 'lodash-es';
import BaseModal from '../../../../_shared/components/BaseModal';
import { PostSaleLineItems } from '../../../../_shared/types/postSale';

import {
  Body,
  CloseButton,
  CloseIcon,
  Header,
  Title,
  StyledRowTitle,
  StyledLineItem,
  StyledRowContent
} from './Styles';

const DocumentsOwingModal = ({ trade, statusKey, onClose }) => {
  const [postSaleLineItemsStatuses, setPostSale] = useState({});
  const intl = useIntl();

  useEffect(() => {
    const lineItems = trade?.onHoldStatuses || [];
    if (lineItems.length > 0) {
      const nextState = lineItems.reduce((acc, lineItem) => {
        if (lineItem.key === PostSaleLineItems.LIEN_RELEASE) {
          acc[PostSaleLineItems.LIEN_RELEASE] = lineItem;
        }
        if (lineItem.key === PostSaleLineItems.OWNERSHIP) {
          acc[PostSaleLineItems.OWNERSHIP] = lineItem;
        }
        return acc;
      }, {});
      setPostSale(nextState);
    }
  }, [trade?.onHoldStatuses]);

  if (!trade) {
    return null;
  }

  return (
    <BaseModal
      width={337}
      isOpen={Boolean(trade)}
      isClickEscClose
      isClickOverlayClose
      onRequestClose={onClose}
      padding="24px 18px"
      testId="payments-on-hold-list-documents-modal"
    >
      <Header>
        <CloseButton
          onClick={onClose}
          data-testid="payments-on-hold-list-documents-modal-close-top-button"
        >
          <span>
            <FormattedMessage id="vdp.close" />
          </span>
          <CloseIcon />
        </CloseButton>
        <Title>
          <FormattedMessage id="paymentsOnHold.documentsOwing" />
        </Title>
      </Header>
      <Body>
        {Object.keys(postSaleLineItemsStatuses)
          .sort()
          .map(li => {
            const { value, isEmail } = postSaleLineItemsStatuses[li];
            return (
              li === statusKey && (
                <StyledLineItem key={li}>
                  <StyledRowTitle>
                    <FormattedMessage id={`paymentsOnHold.${camelCase(li)}`} />
                  </StyledRowTitle>
                  <StyledRowContent>
                    <div
                      /* eslint-disable-next-line */
                      dangerouslySetInnerHTML={{
                        __html: isEmail
                          ? `${intl.formatMessage({
                              id: 'paymentsOnHold.emailTo'
                            })}: <a href="mailto:${value}">${value}</a>`
                          : `${intl.formatMessage({
                              id: 'paymentsOnHold.sendTo'
                            })} <br>${value.replace(/(\\n|\n)/gi, '<br/>')}`
                      }}
                    />
                  </StyledRowContent>
                </StyledLineItem>
              )
            );
          })}
      </Body>
    </BaseModal>
  );
};

export default DocumentsOwingModal;
